/**
 * get isFirst from settings and then return update block
 * @param vodSettings Settings object
 * @param biKey Key indicating, wheter this event happened
 * @param cb function that get isFirst, should return promise when it will happen
 * @returns {Promise.<TResult>|*}
 */
export function biFirst(vodSettings, biKey, cb) {
  const isFirst = getBiIsFirst(vodSettings, biKey);
  return cb(isFirst)
    .then(() => {
      if (isFirst) {
        return getObjWithIsFirst(biKey);
      }
    });
}

export function getBiIsFirst(vodSettings, biKey) {
  return Boolean(!vodSettings[biKey]);
}

export function getObjWithIsFirst(biKey) {
  return { [biKey]: true };
}



// WEBPACK FOOTER //
// ./src/shared/utils/bi/bi-first.js